import { Injectable } from '@angular/core';
import { HttpRequest, HttpHeaders, HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BcAuth } from 'common/auth/auth.service';
import { BcRestApi } from 'common/api/rest-api';
import { BoldRequest } from './csrf-token/csrf-token.service';
import { FileUploadResponseModel } from './models/file-upload-response.model';

@Injectable()
export class FileUploadService {
  constructor(private _httpClient: HttpClient, private _bcAuth: BcAuth, private _bcRestApi: BcRestApi) {}

  upload(files: any, emailThreadId: string, upload: boolean): Promise<FileUploadResponseModel> {
    if (!files) {
      throw new Error('No file specified for upload!');
    }
    if (this._bcAuth.isLoggedIn()) {
      let url = upload
        ? this._bcRestApi.getFileUploadUrl()
        : this._bcRestApi.getEmailAttachmentUploadUrl(emailThreadId);
      const requestHeaders = new HttpHeaders({
        Authorization: 'Basic ' + undefined
      });
      const uploadFormData = new FormData();
      files.forEach((file) => uploadFormData.append('file', file, file.name));
      const uploadRequest = new HttpRequest('POST', url, uploadFormData, {
        headers: requestHeaders,
        withCredentials: true,
        context: new HttpContext().set(BoldRequest, true)
      });

      return this._httpClient
        .request<FileUploadResponseModel>(uploadRequest)
        .toPromise()
        .then((response: HttpResponse<FileUploadResponseModel>) => ({ data: response.body }));
    }
  }

  static getUploadedFileLink(data) {
    return data.location;
  }
}
